// tslint:disable
/**
 * GetInfo
 * Get info api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { ErrorResponse } from '../models';
import { LectureExtraMaterial } from '../models';
import { LectureExtraMaterialCreate } from '../models';
import { LectureExtraMaterialEdit } from '../models';
import { Sort } from '../models';
import { ValidationErrorResponse } from '../models';
/**
 * LectureExtraMaterialApi - axios parameter creator
 * @export
 */
export const LectureExtraMaterialApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * **Security:** `root` or `lecture.company.owner` or `lecture.owner`
         * @summary Delete lecture extra material.
         * @param {string} id 
         * @param {string} material_id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(id: string, material_id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling _delete.');
            }
            // verify required parameter 'material_id' is not null or undefined
            if (material_id === null || material_id === undefined) {
                throw new RequiredError('material_id','Required parameter material_id was null or undefined when calling _delete.');
            }
            const localVarPath = `/v1/lecture/{id}/extra-material/{material_id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"material_id"}}`, encodeURIComponent(String(material_id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * **Security:** `root` or `lecture.company.owner` or `lecture.owner`
         * @summary Create new lecture extra material.
         * @param {string} id 
         * @param {LectureExtraMaterialCreate} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(id: string, body?: LectureExtraMaterialCreate, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling create.');
            }
            const localVarPath = `/v1/lecture/{id}/extra-material/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * **Security:** `root` or `lecture.company.owner` or `lecture.owner`
         * @summary Edit lecture extra material.
         * @param {string} id 
         * @param {string} material_id 
         * @param {LectureExtraMaterialEdit} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edit(id: string, material_id: string, body?: LectureExtraMaterialEdit, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling edit.');
            }
            // verify required parameter 'material_id' is not null or undefined
            if (material_id === null || material_id === undefined) {
                throw new RequiredError('material_id','Required parameter material_id was null or undefined when calling edit.');
            }
            const localVarPath = `/v1/lecture/{id}/extra-material/{material_id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"material_id"}}`, encodeURIComponent(String(material_id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * **Security:** `root` or `lecture.company.owner` or `lecture.owner` or (`lecture.company.employee` and `lecture.enabled`)
         * @summary Get lecture extra material.
         * @param {string} id 
         * @param {string} material_id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id: string, material_id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling get.');
            }
            // verify required parameter 'material_id' is not null or undefined
            if (material_id === null || material_id === undefined) {
                throw new RequiredError('material_id','Required parameter material_id was null or undefined when calling get.');
            }
            const localVarPath = `/v1/lecture/{id}/extra-material/{material_id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"material_id"}}`, encodeURIComponent(String(material_id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * **Security:** `root` or `lecture.company.owner` or `lecture.owner`
         * @summary Sort lecture extra materials.
         * @param {string} id 
         * @param {Array<Sort>} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sort(id: string, body?: Array<Sort>, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling sort.');
            }
            const localVarPath = `/v1/lecture/{id}/extra-material/sort`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LectureExtraMaterialApi - functional programming interface
 * @export
 */
export const LectureExtraMaterialApiFp = function(configuration?: Configuration) {
    return {
        /**
         * **Security:** `root` or `lecture.company.owner` or `lecture.owner`
         * @summary Delete lecture extra material.
         * @param {string} id 
         * @param {string} material_id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(id: string, material_id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = LectureExtraMaterialApiAxiosParamCreator(configuration)._delete(id, material_id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * **Security:** `root` or `lecture.company.owner` or `lecture.owner`
         * @summary Create new lecture extra material.
         * @param {string} id 
         * @param {LectureExtraMaterialCreate} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(id: string, body?: LectureExtraMaterialCreate, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LectureExtraMaterial> {
            const localVarAxiosArgs = LectureExtraMaterialApiAxiosParamCreator(configuration).create(id, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * **Security:** `root` or `lecture.company.owner` or `lecture.owner`
         * @summary Edit lecture extra material.
         * @param {string} id 
         * @param {string} material_id 
         * @param {LectureExtraMaterialEdit} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edit(id: string, material_id: string, body?: LectureExtraMaterialEdit, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LectureExtraMaterial> {
            const localVarAxiosArgs = LectureExtraMaterialApiAxiosParamCreator(configuration).edit(id, material_id, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * **Security:** `root` or `lecture.company.owner` or `lecture.owner` or (`lecture.company.employee` and `lecture.enabled`)
         * @summary Get lecture extra material.
         * @param {string} id 
         * @param {string} material_id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id: string, material_id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LectureExtraMaterial> {
            const localVarAxiosArgs = LectureExtraMaterialApiAxiosParamCreator(configuration).get(id, material_id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * **Security:** `root` or `lecture.company.owner` or `lecture.owner`
         * @summary Sort lecture extra materials.
         * @param {string} id 
         * @param {Array<Sort>} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sort(id: string, body?: Array<Sort>, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = LectureExtraMaterialApiAxiosParamCreator(configuration).sort(id, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * LectureExtraMaterialApi - factory interface
 * @export
 */
export const LectureExtraMaterialApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * **Security:** `root` or `lecture.company.owner` or `lecture.owner`
         * @summary Delete lecture extra material.
         * @param {string} id 
         * @param {string} material_id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(id: string, material_id: string, options?: any) {
            return LectureExtraMaterialApiFp(configuration)._delete(id, material_id, options)(axios, basePath);
        },
        /**
         * **Security:** `root` or `lecture.company.owner` or `lecture.owner`
         * @summary Create new lecture extra material.
         * @param {string} id 
         * @param {LectureExtraMaterialCreate} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(id: string, body?: LectureExtraMaterialCreate, options?: any) {
            return LectureExtraMaterialApiFp(configuration).create(id, body, options)(axios, basePath);
        },
        /**
         * **Security:** `root` or `lecture.company.owner` or `lecture.owner`
         * @summary Edit lecture extra material.
         * @param {string} id 
         * @param {string} material_id 
         * @param {LectureExtraMaterialEdit} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edit(id: string, material_id: string, body?: LectureExtraMaterialEdit, options?: any) {
            return LectureExtraMaterialApiFp(configuration).edit(id, material_id, body, options)(axios, basePath);
        },
        /**
         * **Security:** `root` or `lecture.company.owner` or `lecture.owner` or (`lecture.company.employee` and `lecture.enabled`)
         * @summary Get lecture extra material.
         * @param {string} id 
         * @param {string} material_id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id: string, material_id: string, options?: any) {
            return LectureExtraMaterialApiFp(configuration).get(id, material_id, options)(axios, basePath);
        },
        /**
         * **Security:** `root` or `lecture.company.owner` or `lecture.owner`
         * @summary Sort lecture extra materials.
         * @param {string} id 
         * @param {Array<Sort>} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sort(id: string, body?: Array<Sort>, options?: any) {
            return LectureExtraMaterialApiFp(configuration).sort(id, body, options)(axios, basePath);
        },
    };
};

/**
 * LectureExtraMaterialApi - object-oriented interface
 * @export
 * @class LectureExtraMaterialApi
 * @extends {BaseAPI}
 */
export class LectureExtraMaterialApi extends BaseAPI {
    /**
     * **Security:** `root` or `lecture.company.owner` or `lecture.owner`
     * @summary Delete lecture extra material.
     * @param {string} id 
     * @param {string} material_id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LectureExtraMaterialApi
     */
    public _delete(id: string, material_id: string, options?: any) {
        return LectureExtraMaterialApiFp(this.configuration)._delete(id, material_id, options)(this.axios, this.basePath);
    }

    /**
     * **Security:** `root` or `lecture.company.owner` or `lecture.owner`
     * @summary Create new lecture extra material.
     * @param {string} id 
     * @param {LectureExtraMaterialCreate} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LectureExtraMaterialApi
     */
    public create(id: string, body?: LectureExtraMaterialCreate, options?: any) {
        return LectureExtraMaterialApiFp(this.configuration).create(id, body, options)(this.axios, this.basePath);
    }

    /**
     * **Security:** `root` or `lecture.company.owner` or `lecture.owner`
     * @summary Edit lecture extra material.
     * @param {string} id 
     * @param {string} material_id 
     * @param {LectureExtraMaterialEdit} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LectureExtraMaterialApi
     */
    public edit(id: string, material_id: string, body?: LectureExtraMaterialEdit, options?: any) {
        return LectureExtraMaterialApiFp(this.configuration).edit(id, material_id, body, options)(this.axios, this.basePath);
    }

    /**
     * **Security:** `root` or `lecture.company.owner` or `lecture.owner` or (`lecture.company.employee` and `lecture.enabled`)
     * @summary Get lecture extra material.
     * @param {string} id 
     * @param {string} material_id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LectureExtraMaterialApi
     */
    public get(id: string, material_id: string, options?: any) {
        return LectureExtraMaterialApiFp(this.configuration).get(id, material_id, options)(this.axios, this.basePath);
    }

    /**
     * **Security:** `root` or `lecture.company.owner` or `lecture.owner`
     * @summary Sort lecture extra materials.
     * @param {string} id 
     * @param {Array<Sort>} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LectureExtraMaterialApi
     */
    public sort(id: string, body?: Array<Sort>, options?: any) {
        return LectureExtraMaterialApiFp(this.configuration).sort(id, body, options)(this.axios, this.basePath);
    }

}
